import DataConst from 'consts/DataConst';
import BaseController from './BaseController';

class CategoryController extends BaseController {
  model = DataConst.MODELS.CATEGORY;
}

export default new CategoryController();
